import React, { Component } from 'react'

import T from '../../translate/T'

import { Col, Row, Container } from '../../atoms/Grid'
import Loading from '../../atoms/Loading'
import { findGetParameter, insertParam } from '../../helpers/Url'
import Modal from '../../atoms/Modal'
import Font from '../../atoms/Font'
import Button from '../../atoms/Button'
import ActionBtnIcon from '../../molecules/ActionBtnIcon'
import Article from '../Article'

import * as timeline from '../../utils/timeline'


import Modais from './Modais'

import BoxText from './Containers/BoxText'
import BoxAttachment from './Containers/BoxAttachment'
import BoxImage from './Containers/BoxImage'
import BoxArticle from './Containers/BoxArticle'
import Comments from './Comments'

import Masonry from '../../atoms/Masonry'

import style from './style.css'
class Timeline extends Component {

    state = {
        modal: null,
        id: null,
        status: 'nostart',
        data: null,
        posts: [],
        total: 0,
        modalData: {},
        modalConfirm: null,
        toDelete: null,
        statusMore: 'done',
        openTargetArticle: null
    }

    loadTimeline() {
        if(this.state.status === 'loading') return

        this.setState({
            status: 'loading',
            posts: [],
            total: 0,
            data: null,
            id: null
        })

        timeline.get(this.props.type, this.props.id)
        .then(resp => {
            if(resp.errors) {
                this.setState({
                    status: 'error'
                })
                this.isLoaded(false)
                return
            }
            this.setState({
                status: 'done',
                id: resp.id,
                data: resp
            })
            this.isLoaded(true)
            this.loadMorePost()
        })
    }

    tokenCloseUrl() {
        this.setState({
            openTargetArticle: null
        })
        
        var url = window.location.href;

        if(url.indexOf("?") !== -1) {
            var resUrl = url.split("?");

            if(typeof window.history.pushState === 'function') {
                window.history.pushState({}, "Hide", resUrl[0]);
            }
        }
    }

    isLoaded(success) {
        if(this.props.handleLoaded) 
        this.props.handleLoaded(success)
    }

    componentWillMount() {
        this.loadTimeline()
    }
    
    componentWillUpdate() {
        if(findGetParameter('post_target') && this.state.openTargetArticle !== findGetParameter('post_target'))
            this.handleOpenArticle(findGetParameter('post_target'))
    }

    handleOpenArticle(token) {
        this.setState({
            openTargetArticle: token
        })
    }

    componentWillReceiveProps(nextProps) {  
        if(nextProps.isLogged !== this.props.isLogged) {
            this.loadTimeline()      
        }
    }
    
    loadMorePost() {
        this.setState({
            statusMore: 'loading'
        })
        timeline.loadPosts(this.state.id, this.state.posts.length)
        .then(resp => {
            let posts = this.state.posts
            posts = posts.concat(resp.result)
            this.setState(state => ({
                posts,
                total: resp.total
            }))

            this.setState({
                statusMore: 'done'
            })
        })
    }

    openModal(id) {
        this.setState({
            modal: id
        })
    }

    handleDelete(id) {
        this.setState(state => ({
            toDelete: id,
            modalConfirm: 'deletePost',
            total: state.total - 1
        }))
    }

    confirmDelete(id) {
        this.refs[`post${id}`].style.opacity = '0.3'

        let posts = this.state.posts.filter(post => post.id !== id)

        timeline.deletePost(id)
        .then(resp => {
            this.setState({
                posts
            })
        })
    }

    handleEdit(id) {
        this.setState({
            modal: 'article',
            modalData: {
                id
            }
        })
    }

    handleNewPost(data) {
        let posts = this.state.posts
        let arr = []
        arr.push(data)
        arr = arr.concat(posts)
        this.setState({
            posts: arr,
            total: this.state.total+1
        })
    }

    handleApprove(id) {
        let posts = this.state.posts
        let key = null
        posts.find((v, k) => {
            key = k
            return v.id === id
        })
        
        timeline.approvePost(id)
        .then(resp => {
            posts[key] = resp
            this.setState({
                posts
            })
        })

    }


    render() {
        return (
            <div style={{float: 'left', width: '100%'}}>
                {this.state.status === 'done' && (
                    <div>
                        <Row>
                            <Col size="6">
                                <div className={style.header}>
                                    <h3>
                                        <div dangerouslySetInnerHTML={{__html: this.props.title}}></div>
                                    </h3>
                                </div>
                            </Col>
                            {(this.state.data.open_to !== 'admin' || this.state.data.is_admin === 1) && this.props.isLogged && (
                                <Col size="6">
                                    <div className={style.maker}>
                                        <span className={style.info}>{T.text('c_timeline_call_to_actions')}</span>
                                        <div className={style.iconGroup}>
                                            <span className={style.icon}>
                                                <ActionBtnIcon size={40} icon='edit' theme='rounded-orange' action={() => { this.openModal('post') }} />
                                            </span>
                                            <span className={style.icon}>
                                                <ActionBtnIcon size={40} icon='picture' theme='rounded-orange' action={() => { this.openModal('image') }} />
                                            </span>
                                            <span className={style.icon}>
                                                <ActionBtnIcon size={40} icon='document' theme='rounded-orange' action={() => { this.openModal('attachment') }} />
                                            </span>
                                            <span className={style.icon}>
                                                <ActionBtnIcon size={40} icon='menu' theme='rounded-orange' action={() => { this.openModal('article') }} />
                                            </span>
                                        </div>
                                    </div>
                                </Col>
                            )}
                        </Row>

                        {(this.state.data.open_to !== 'admin' || this.state.data.is_admin === 1) && this.props.isLogged && (
                            <div>
                                <Modais
                                    modal={this.state.modal}
                                    modalData={this.state.modalData}
                                    handleClose={ () => {
                                        this.setState({
                                            modal: false
                                        })
                                    }}
                                    handleNewPost={
                                        (data) => {
                                            this.handleNewPost(data)
                                        }
                                    }
                                    tlid={this.state.id} />

                                <Modal active={this.state.modalConfirm === 'deletePost'}>
                                    <div style={{textAlign: 'center'}}>
                                        <Col>
                                            <p><Font size={30} color='#4a4a4a' weight='100'>{T.text('c_confirm')}</Font></p>
                                            <p><Font color='#4a4a4a'>{T.text('c_confirm_delete_post')}</Font></p>
                                        </Col>
                                        <Col style={{ marginTop: '20px' }}>
                                            <Col size="6">
                                                <Button theme='light' onClick={() => { this.setState({
                                                    modalConfirm: null
                                                }) }}>{T.text('c_cancel')}</Button>
                                            </Col>
                                            <Col size="6">
                                                <Button
                                                    theme='primary'
                                                    onClick={() => {
                                                        this.confirmDelete(this.state.toDelete)
                                                        this.setState({
                                                            modalConfirm: null
                                                        })
                                                    }}>
                                                    {T.text('c_delete')}
                                                </Button>
                                            </Col>
                                        </Col>
                                    </div>
                                </Modal>
                            </div>
                        )}
                    </div>
                )}
                        


                {this.state.status === 'loading' && (
                    <Loading />
                )}

                {this.state.status === 'done' && (
                    <div style={{marginTop: '20px'}}>
                        <Masonry>
                            {this.state.posts.map(post => (
                                <div ref={`post${post.id}`} key={post.id}>
                                    {post.post_type === 'text' && (
                                        <BoxText
                                            data={post}
                                            handleDelete={ (id) => this.handleDelete(id) }
                                            is_admin={ this.state.data.is_admin  }
                                            needApprove={ post.status === '2' }
                                            onApprove={() => this.handleApprove(post.id)}
                                            >
                                            {post.status === '3' && (this.props.isLogged || post.comments > 0)  && (
                                                <Comments isLogged={this.props.isLogged} user={this.props.user} num={post.comments} id={post.id} />
                                            )}
                                        </BoxText>
                                    )}
                                    {post.post_type === 'file' && (
                                        <BoxAttachment
                                            data={post}
                                            handleDelete={ (id) => this.handleDelete(id) }
                                            is_admin={ this.state.data.is_admin  }
                                            needApprove={ post.status === '2' }
                                            onApprove={() => this.handleApprove(post.id)}>
                                            {post.status === '3' && (this.props.isLogged || post.comments > 0)  && (
                                                <Comments isLogged={this.props.isLogged} user={this.props.user} num={post.comments} id={post.id} />
                                            )}
                                        </BoxAttachment>
                                    )}
                                    { ( post.post_type === 'image' || post.post_type === 'multipleimage' ) && (
                                        <BoxImage
                                            data={post}
                                            handleDelete={ (id) => this.handleDelete(id) }
                                            is_admin={ this.state.data.is_admin  }
                                            needApprove={ post.status === '2' }
                                            onApprove={() => this.handleApprove(post.id)}>
                                            {post.status === '3' && (this.props.isLogged || post.comments > 0)  && (
                                                <Comments isLogged={this.props.isLogged} user={this.props.user} num={post.comments} id={post.id} />
                                            )}
                                        </BoxImage>
                                    )}
                                    {post.post_type === 'article' && (
                                        <BoxArticle
                                            openArticle={token => {
                                                insertParam('post_target', token)
                                                this.handleOpenArticle(token)
                                            }}
                                            data={post}
                                            handleEdit={ (id) => this.handleEdit(id) }
                                            handleDelete={ (id) => this.handleDelete(id) }
                                            is_admin={ this.state.data.is_admin  }
                                            needApprove={ post.status === '2' }
                                            onApprove={() => this.handleApprove(post.id)}>
                                            {post.status === '3' && (this.props.isLogged || post.comments > 0)  && (
                                                <Comments isLogged={this.props.isLogged} user={this.props.user} num={post.comments} id={post.id} />
                                            )}
                                        </BoxArticle>
                                    )}
                                </div>
                            ))}
                        </Masonry>

                        {this.state.posts.length < this.state.total ? (
                            <div style={{marginTop: '20px', float: 'left', width: '100%', textAlign: 'center' }}>
                                <Button inline theme='light' onClick={() => this.loadMorePost()}
                                    disabled={(this.state.statusMore === 'loading') ? true : false}
                                >
                                    {(this.state.statusMore === 'loading') ? (
                                        <Loading
                                            color='#7000e3'
                                            size='30px' />
                                    ) : T.text('c_load_more')}
                                </Button>
                            </div>
                        ) : (
                            <div>
                                { this.state.statusMore === 'loading' && (
                                    <Loading
                                        color='#7000e3'
                                        size='30px' />   
                                )}
                            </div>
                        )}
                    </div>
                ) }

                
                <Modal
                    active={this.state.openTargetArticle}
                    full
                    style={{width: '100%' }}
                    handleClose={() => this.tokenCloseUrl()}>
                    <Container>
                        <Article
                            userData={this.props.user}
                            isLogged={this.props.isLogged}
                            token={this.state.openTargetArticle}
                            notFound={() => this.tokenCloseUrl()} />
                    </Container>
                </Modal>

            </div>
        )
    }
}
export default Timeline


// WEBPACK FOOTER //
// ./src/SPRINTA/organisms/Timeline/index.js